import Table from '@shared/components/Table';

import { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { notifySuccess, notifyError } from '@config/tostifyConfig/tostifyConfig';

import useLocations from '@modules/organizationalStructure/locations/hooks/useLocations';

import { locations } from '../services/locations';

import LocationsForm from './LocationsForm';

import DeleteModal from '@shared/components/DeleteModal';

import LocationTranslations from './LocationTranslations';

import { COMMON_BUTTONS } from '@config/actionButtonConfigs';

import ActionButtons from '@shared/components/ActionButtons';

import { useStatusBadge } from '@shared/components/StatusBadge';

import { useReportGenerator } from '@shared/hooks/useReportGenerator';

import { faSpinner } from '@fortawesome/free-solid-svg-icons';



export default function Locations() {

    const { t } = useTranslation();

    const [locationsData, setLocationsData] = useState([]);

    const [selectedData, setSelectedData] = useState(null);

    const [searchQuery, setSearchQuery] = useState({ abbreviation: '', description: '', cityName: '' });

    const [selectedActive, setSelectedActive] = useState('true'); // Default to active

    const [modalState, setModalState] = useState({ visible: false, type: null, editData: null });



    const { statusBadge } = useStatusBadge();

    const {

        countries,

        fetchCountries,

        selectedCountry,

        setSelectedCountry,

    } = useLocations();



    const countriesOptions = countries.map(country => ({

        id: country.countryCode,

        name: country.countryNameBg

    }));



    const selectedCountryObject = countries.find(country => country.countryCode === selectedCountry);



    useEffect(() => {

        fetchCountries();

    }, [fetchCountries]);



    useEffect(() => {

        const fetchLocations = async () => {

            if (!selectedCountry) {

                setLocationsData([]);

                return;

            }

            try {

                const searchParams = {};

                if (searchQuery.abbreviation) {

                    searchParams.description = searchQuery.abbreviation;

                }

                if (searchQuery.description) {

                    searchParams.name = searchQuery.description;

                }

                if (searchQuery.cityName) {

                    searchParams.cityName = searchQuery.cityName;

                }

                if (selectedActive !== null && selectedActive !== '') {

                    searchParams.active = selectedActive === 'true';

                }

                

                const locationsData = await locations.getLocations(searchParams);

                setLocationsData(locationsData.content || []);

            } catch (error) {

                console.error('❌ [useEffect] Error fetching locations:', error);

            }

        };

        fetchLocations();

    }, [selectedCountry, selectedActive]);



    const handleSearchClick = async (getDataFunc, params = {}) => {

        

        const fetchLocations = async () => {

            if (!selectedCountry) {

                setLocationsData([]);

                return;

            }

            try {

                const searchParams = {};

                if (searchQuery.abbreviation) {

                    searchParams.description = searchQuery.abbreviation;

                }

                if (searchQuery.description) {

                    searchParams.name = searchQuery.description;

                }

                if (searchQuery.cityName) {

                    searchParams.cityName = searchQuery.cityName;

                }

                if (selectedActive !== null && selectedActive !== '') {

                    searchParams.active = selectedActive === 'true';

                }

                

                const locationsData = await locations.getLocations(searchParams);

                setLocationsData(locationsData.content || []);

            } catch (error) {

                console.error('❌ [handleSearchClick] Error fetching locations:', error);

            }

        };

        fetchLocations();

    };



        const handleCheckboxChange = (index) => {

        const location = locationsData[index];

        setSelectedData(selectedData === location.id ? null : location.id);

    };



    // Report generator for locations

    const { 

        generatePdfReport, 

        generateExcelReport,

        pdfLoading,

        excelLoading

    } = useReportGenerator({

        title: t('organizationalStructure.locations.title'),

        columns: [

            { key: 'locationCode', label: t('organizationalStructure.locations.table.headers.codeLocation') },

            { key: 'name', label: t('organizationalStructure.locations.table.headers.title') },

            { key: 'regionName', label: t('organizationalStructure.locations.table.headers.district') },

            { key: 'subRegionName', label: t('organizationalStructure.locations.table.headers.municipality') },

            { key: 'cityName', label: t('organizationalStructure.locations.table.headers.city') },

            { key: 'address1', label: t('organizationalStructure.locations.form.street') },

            { key: 'address2', label: t('organizationalStructure.locations.form.streetNo') },

            { key: 'address3', label: t('organizationalStructure.locations.form.streetFloor') },

            { key: 'postal', label: t('organizationalStructure.locations.form.postalCode') },

        ],

        fileName: 'locations_report',

        companyName: '',

        reportService: () => {

            const searchParams = {};

            if (searchQuery.abbreviation) {

                searchParams.description = searchQuery.abbreviation;

            }

            if (searchQuery.description) {

                searchParams.name = searchQuery.description;

            }

            if (searchQuery.cityName) {

                searchParams.cityName = searchQuery.cityName;

            }

            if (selectedActive !== null && selectedActive !== '') {

                searchParams.active = selectedActive === 'true';

            }

            return locations.getLocationsReportData(searchParams);

        },

        customStyles: {}

    });



    const handleOpenModal = (type) => {

        if (type === 'edit' && selectedData) {

            const location = locationsData.find(l => l.id === selectedData);

            setModalState({ visible: true, type: type, editData: location });

        } else {

            setModalState({ visible: true, type: type, editData: null });

        }

    };



    const handleCloseModal = () => {

        setModalState({ visible: false, type: null, editData: null });

    };



    const handleConfirm = async (formData) => {

        try {

            if (modalState.type === 'add') {

                await locations.createLocation(formData);

                notifySuccess(t('common.createdSuccessfully'));

            } else if (modalState.type === 'edit') {

                await locations.updateLocation(selectedData, formData);

                notifySuccess(t('common.updatedSuccessfully'));

            } else if (modalState.type === 'delete') {

                await locations.deleteLocation(selectedData);

                notifySuccess(t('common.deletedSuccessfully'));

                setSelectedData(null);

            } 

            // Close modal first

            handleCloseModal();

            // Refresh data after successful operation

            const searchParams = {};

            if (searchQuery.abbreviation) {

                searchParams.description = searchQuery.abbreviation;

            }

            if (searchQuery.description) {

                searchParams.name = searchQuery.description;

            }

            if (searchQuery.cityName) {

                searchParams.cityName = searchQuery.cityName;

            }

            if (selectedActive !== null && selectedActive !== '') {

                searchParams.active = selectedActive === 'true';

            }

            

            

            const updatedLocationsData = await locations.getLocations(searchParams);

            setLocationsData(updatedLocationsData.content || []);

        } catch (error) {

            const errorMessage = error.response?.data?.message || t('common.error');

            notifyError(errorMessage);

        }

    };





    const actionButtons = (

        <ActionButtons

            buttons={[

                { ...COMMON_BUTTONS.ADD, onClick: () => handleOpenModal('add') },

                { ...COMMON_BUTTONS.EDIT, onClick: () => handleOpenModal('edit') },

                { ...COMMON_BUTTONS.DELETE, onClick: () => handleOpenModal('delete') },

                { ...COMMON_BUTTONS.TRANSLATE, onClick: () => handleOpenModal('translations') },

                { 

                    ...COMMON_BUTTONS.DOWNLOAD_PDF, 

                    onClick: generatePdfReport,

                    disabled: pdfLoading,

                    icon: pdfLoading ? faSpinner : COMMON_BUTTONS.DOWNLOAD_PDF.icon,

                    iconProps: pdfLoading ? { spin: true } : {},

                    title: pdfLoading ? "Генериране на PDF..." : "common.downloadPDF",

                    showWhen: 'always'

                },

                { 

                    ...COMMON_BUTTONS.EXCEL, 

                    onClick: generateExcelReport,

                    disabled: excelLoading,

                    icon: excelLoading ? faSpinner : COMMON_BUTTONS.EXCEL.icon,

                    iconProps: excelLoading ? { spin: true } : {},

                    title: excelLoading ? "Генериране на Excel..." : "common.downloadExcel",

                    showWhen: 'always'

                },

            ]}

            selectedRecord={selectedData}

        />

    );







    const columns = [

        {

            key: 'locationCode', label: t('organizationalStructure.locations.table.headers.codeLocation'),

        },

        {

            key: 'name', label: t('organizationalStructure.locations.table.headers.title'),

        },

        {

            key: 'description', label: t('organizationalStructure.locations.table.headers.abbreviation'),

        },

        {

            key: 'cityName', label: t('organizationalStructure.locations.table.headers.city'),

        },

        {

            key: 'regionName', label: t('organizationalStructure.locations.table.headers.district'),

        },

        {

            key: 'subRegionName', label: t('organizationalStructure.locations.table.headers.municipality'),

        },

        {

            key: 'translated', label: t('organizationalStructure.locations.table.headers.transliteration'),

        },

    ];



    const searchOptions = [

        {

            key: 'abbreviation', label: 'abbreviation',

        },

        {

            key: 'description', label: 'title',

        },

        {

            key: 'cityName', label: 'populatedPlace',

        }



    ]

    return (

        <>

            <Table

                title={t('organizationalStructure.locations.title')}

                columns={columns}

                data={(locationsData || []).map((item, index) => ({ ...item, index }))}

                actionButtons={actionButtons}

                showCustomSearch={false}

                searchOptions={searchOptions}

                showActiveSelect={true}

                searchQuery={searchQuery}

                setSearchQuery={setSearchQuery}

                handleSearchClick={handleSearchClick}

                getData={() => {}}

                handleCheckboxChange={handleCheckboxChange}

                selectedData={selectedData}

                selectedActive={selectedActive}

                setSelectedActive={setSelectedActive}

                showPageSizeSelector={false}

                showPagination={false}

                showPreviousPage={false}

                showCountriesSelect={true}

                selectedCountry={selectedCountry}

                setSelectedCountry={setSelectedCountry}

                countriesOptions={countriesOptions}

                setCountriesOptions={() => { }}

                renderCell={(item, column) => statusBadge(item, column)}

            />

            {modalState.visible && (modalState.type === 'add' || modalState.type === 'edit') && (

                <LocationsForm onClose={handleCloseModal} editData={modalState.editData} selectedCountry={selectedCountryObject} setSelectedCountry={setSelectedCountry} handleConfirm={handleConfirm} />

            )}

            {modalState.visible && modalState.type === 'delete' && (

                <DeleteModal onClose={handleCloseModal} onConfirm={handleConfirm} selectedData={selectedData} name={locationsData.find(l => l.id === selectedData)?.name} entityType="record" />

            )}

            {modalState.visible && modalState.type === 'translations' && (

                <LocationTranslations 

                    onClose={handleCloseModal} 

                    location={locationsData.find(l => l.id === selectedData)}

                    onSuccess={() => {

                        // Refresh locations data after successful translation

                        const searchParams = {};

                        if (searchQuery.abbreviation) {

                            searchParams.description = searchQuery.abbreviation;

                        }

                        if (searchQuery.description) {

                            searchParams.name = searchQuery.description;

                        }

                        if (searchQuery.cityName) {

                            searchParams.cityName = searchQuery.cityName;

                        }

                        if (selectedActive !== null && selectedActive !== '') {

                            searchParams.active = selectedActive === 'true';

                        }

                        

                        locations.getLocations(searchParams).then(response => {

                            setLocationsData(response.content || []);

                        }).catch(error => {

                            console.error('Error refreshing locations after translation:', error);

                        });

                    }}

                />

            )}

        </>

    )

}

